var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovieIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 168,
    viewBox: "0 0 157 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2964 119.56L73.7225 128.134V149.125L103.287 119.56L73.7225 89.9949V110.986L82.2964 119.56Z",
    fill: "url(#paint0_linear_1181_1134)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.586 52.5402H22.1405L149.826 27.6709C151.722 27.2999 152.968 25.4564 152.597 23.5608L148.69 3.50298C148.319 1.60735 146.476 0.360986 144.58 0.731997L2.83636 28.3375C0.940725 28.7085 -0.30564 30.552 0.0653714 32.4476L3.532 50.2562L3.97258 52.5054L4.64504 55.9489H4.69141C4.69141 55.9489 4.69141 56.0126 4.69141 56.0474V153.809C4.69141 161.27 10.7609 167.333 18.2159 167.333H142.557C150.023 167.333 156.093 161.258 156.093 153.797V56.0474C156.093 54.117 154.522 52.5402 152.586 52.5402ZM124.574 57.688L134.366 74.4704H115.815L106.024 57.688H124.574ZM97.9079 57.688L107.699 74.4704H89.1486L79.3574 57.688H97.9079ZM71.2415 57.688L81.0327 74.4704H62.4822L52.691 57.688H71.2415ZM44.5751 57.688L54.3663 74.4704H35.8158L26.0245 57.688H44.5751ZM7.72327 44.8417L11.6711 49.3402L8.70877 49.9141L7.72327 44.8417ZM143.948 6.10006L146.134 17.3115L137.409 7.37541L143.948 6.10006ZM129.444 8.92322L142.545 23.8506L124.337 27.3984L111.235 12.471L129.444 8.92322ZM103.27 14.0188L116.372 28.9462L98.163 32.494L85.0617 17.5666L103.27 14.0188ZM77.0965 19.1144L90.1978 34.0418L71.9893 37.5896L58.888 22.6622L77.0965 19.1144ZM50.9229 24.21L64.0242 39.1374L45.8157 42.6852L32.7143 27.7578L50.9229 24.21ZM24.7492 29.3056L37.8505 44.233L19.642 47.7808L6.53487 32.8592L24.7434 29.3114L24.7492 29.3056ZM9.83339 57.6822H17.9145L27.7057 74.4646H9.8276V57.6822H9.83339ZM150.191 153.791C150.191 158 146.765 161.426 142.557 161.426H18.2101C14.0073 161.426 10.587 158.006 10.587 153.803V80.3718H150.186V153.791H150.191ZM142.487 74.4704L132.696 57.688H150.951V74.4704H142.487Z",
    fill: "#004B64"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1181_1134",
    x1: 103.287,
    y1: 119.561,
    x2: 73.7238,
    y2: 119.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1B2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieIcon);
export default __webpack_public_path__ + "static/media/movieIcon.7ac4498736813fb6d8125e577f9eacf6.svg";
export { ForwardRef as ReactComponent };